(function () {
  'use strict';
  class Controller {}
  angular
    .module('actions')
    .component('displayUpdateAction', {
      controller: Controller,
      templateUrl: 'actions/display/update/update-display.action.html',
      bindings: {
        display: '<',
        displayId: '<',
        then: '&',
        catch: '&'
      }
    });
}());
